module.exports = __webpack_public_path__ + "static/img/face4.d5afaa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face4.jpg
// module id = djfg
// module chunks = 0